import { dedupeMixin } from '@open-wc/dedupe-mixin';
export { default as rippleEffectStyles } from './styles.css.js';
function UseRippleEffectImplementation(Class) {
    class UseRippleEffectElement extends Class {
        attachRippleEffect(element) {
            element.addEventListener('click', this.createRippleEffect);
        }
        detachRippleEffect(element) {
            element.removeEventListener('click', this.createRippleEffect);
        }
        /**
         * Create ripple effect
         * @param {Event} event
         */
        createRippleEffect(event) {
            const element = event.currentTarget;
            const offsetInfo = element.getBoundingClientRect();
            const maxLength = offsetInfo.width > offsetInfo.height ? offsetInfo.width : offsetInfo.height;
            const circleD = maxLength * 2;
            const oldRippleContainer = element.querySelector('.ripple-container');
            // Create new rippleContainer element
            const createRippleContainer = () => {
                const rippleContainer = document.createElement('div');
                // Add styling to rippleContainer
                rippleContainer.style.position = 'fixed';
                rippleContainer.style.zIndex = '99';
                rippleContainer.style.width = `${offsetInfo.width}px`;
                rippleContainer.style.left = `${offsetInfo.left}px`;
                rippleContainer.style.top = `${offsetInfo.top}px`;
                rippleContainer.style.height = `${offsetInfo.height}px`;
                rippleContainer.className = 'ripple-container';
                rippleContainer.style.overflow = 'hidden';
                return rippleContainer;
            };
            // Create ripple element
            const createRipple = () => {
                const ripple = document.createElement('div');
                ripple.style.position = 'absolute';
                ripple.style.width = `${circleD}px`;
                ripple.style.height = `${circleD}px`;
                ripple.style.borderRadius = '500px';
                ripple.style.left = `${event.pageX - offsetInfo.left - circleD / 2}px`;
                ripple.style.top = `${event.pageY - offsetInfo.top - circleD / 2}px`;
                ripple.className = 'ripple';
                return ripple;
            };
            // Remove old rippleContainer if it still exist
            if (oldRippleContainer) {
                element.removeChild(oldRippleContainer);
            }
            // Create ripple elements needed for ripple effect
            const rippleContainer = createRippleContainer();
            const ripple = createRipple();
            // append element to button
            element.appendChild(rippleContainer);
            rippleContainer.appendChild(ripple);
            // remove when animation has ended
            ripple.addEventListener('animationend', () => {
                element.removeChild(rippleContainer);
            }, false);
        }
    }
    return UseRippleEffectElement;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const UseRippleEffect = dedupeMixin(UseRippleEffectImplementation);
